import React, { useState, useRef, useCallback } from 'react';
import { Microphone, Stop } from '@phosphor-icons/react';

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

export function VoiceInputButton({ onTranscript, disabled = false, className = '' }) {
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);

  const toggle = useCallback(() => {
    if (!SpeechRecognition) {
      alert('Voice input is not supported in this browser. Try Chrome or Edge.');
      return;
    }

    if (listening) {
      recognitionRef.current?.stop();
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.continuous = false;

    recognition.onresult = (event) => {
      const text = event.results[0][0].transcript;
      onTranscript(text);
    };

    recognition.onend = () => setListening(false);
    recognition.onerror = () => setListening(false);

    recognitionRef.current = recognition;
    recognition.start();
    setListening(true);
  }, [listening, onTranscript]);

  if (!SpeechRecognition) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={disabled}
      data-testid="voice-input-button"
      className={`inline-flex items-center justify-center rounded-sm transition-colors ${
        listening
          ? 'bg-red-500/20 text-red-400 border-red-500/40 animate-pulse'
          : 'bg-[#111111] text-[#999999] border-[#333333] hover:text-[#22C55E] hover:border-[#22C55E]'
      } border w-9 h-9 ${className}`}
      title={listening ? 'Stop recording' : 'Voice input'}
    >
      {listening ? <Stop className="w-4 h-4" weight="fill" /> : <Microphone className="w-4 h-4" />}
    </button>
  );
}
